import { useEffect } from 'react'
import useInternationalization from '@hooks/useInternationalization'

import calculatePrice from '@client/services/proposal'

export default function useCalculateDiscount(
  contact,
  setFunnelStage,
  funnelStage
) {
  const { country } = useInternationalization()

  async function calculateDiscount() {
    const coupon =
      (contact &&
        contact.commercialOffer &&
        contact.commercialOffer.couponCode) ||
      (contact && contact.couponCode)

    const { data } = await calculatePrice(
      contact.employeesNumber,
      country,
      coupon
    )

    const discount = (data.valueWithoutDiscount - data.value) * -1

    const offer = {
      discount,
      proposalValue: data.value,
      proposalValueWithoutDiscount: data.valueWithoutDiscount,
      couponCode: data.coupon.code,
      id: contact.id,
      funnelStage,
      dependentsValue: data.dependentsValue,
      commercialOfferLink: `${window.location.protocol}//${window.location.host}/digital/${country}/simulate/commercial-offer?magic-link=${contact.magicLink}`,
    }

    await setFunnelStage(offer)
  }

  useEffect(() => {
    if (contact && contact.employeesNumber > 0) {
      calculateDiscount()
    }
  }, [contact.employeesNumber])
}
